import React, { Component } from "react";
import { SearchResponse, SearchRequest } from "../../rpc/admin/search_pb";
import Adapter from "./adapter";

class NumericRangeFacetProps {
    adapter?: Adapter;
    field: string = '';
    value?: SearchResponse.Aggregation.Range;
}

class NumericRangeFacetState { }

class NumericRangeFacet extends Component<NumericRangeFacetProps, NumericRangeFacetState> {

    toggle = () => {
        const filter = new SearchRequest.Filter();
        filter.setField(this.props.field);
        const rf = new SearchRequest.Filter.Range();
        rf.setFrom(this.props.value!.getFrom());
        rf.setTo(this.props.value!.getTo());
        filter.setRangeFilter(rf);
        if (this.props.value!.getChecked()) {
            this.props.adapter!.removeFilter(filter);
        } else {
            this.props.adapter!.addFilter(filter);
        }
    }

    render() {
        return (
            <div className="search-facet">
                <label className="checkbox">
                    <input type="checkbox" checked={this.props.value!.getChecked()} onChange={this.toggle} />
                    <span className="search-facet-label">{this.props.value!.getLabel()}</span>
                </label>
                <div className="search-facet-count">{this.props.value!.getCount()}</div>
            </div>
        );
    }
}

export default NumericRangeFacet;